import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { get_automation_portal_logo_url } from '@/utils/urls.ts';
import { AUTOMATION_PORTAL_KEY } from '@/utils/queryKeys.ts';
import { AutomationPortal } from '@/types/automations.ts';

type UploadAutomationPortalLogoParams = {
  automationId: string;
  file: File;
};

const useUploadAutomationPortalLogo = (): UseMutationResult<
  AutomationPortal,
  AxiosError,
  UploadAutomationPortalLogoParams
> => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ automationId, file }: UploadAutomationPortalLogoParams) => {
      const formData = new FormData();
      formData.append('file', file);
      const response = await apiClient.post(
        get_automation_portal_logo_url(automationId),
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      return response.data;
    },
    onSuccess: async (portal: AutomationPortal) => {
      queryClient.setQueryData(AUTOMATION_PORTAL_KEY(portal.automation_id), portal);
      await queryClient.invalidateQueries({
        queryKey: AUTOMATION_PORTAL_KEY(portal.automation_id),
      });
    },
  });
};

export default useUploadAutomationPortalLogo;
